<div class="modal-header">
    <h3 class="modal-title font-bold" id="modal-title">{{title}}</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancel()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body" id="modal-body">
    <img src="{{fromParent}}" style="width: 100%; height: 70%;"/>
</div>
<div class="modal-footer confirm-footer">
    <!-- buttons for Cancel Confirmation Modal -->
    <button class="btn btn-primary btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>